import SegredoJustica from '@mui/icons-material/Lock';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroSegredoJustica extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Segredo de justiça';
    }

    getIconeFiltroRapido() {
        return <SegredoJustica />;
    }

    filtroRapido = {
        valor: true
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return registro.segredoJustica;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
